/* Not exported with the library. You'll want something similar to this for uniquely identifying external hosts in your App */
const IHEER = Symbol("IHEER2");
const IDADMIN = Symbol("IDADMIN");

export const apiHosts = {
  IHEER,
  IDADMIN,
};
